module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/main-visual_stay-d5ec0f22997c803d79c9112c07348610.jpg";